import { render, staticRenderFns } from "./NumberText.vue?vue&type=template&id=5a1aec40&"
import script from "./NumberText.vue?vue&type=script&lang=ts&"
export * from "./NumberText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports